module.exports = __webpack_public_path__ + "static/img/step3_en@2x.951b1c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step3_en@2x.jpg
// module id = 536
// module chunks = 0